module.exports = __webpack_public_path__ + "img/20.4cb8bf9c.jpg";